// extracted by mini-css-extract-plugin
export default {"widthContent":"WidthContent_widthContent__mA6L4","widthContent__app":"WidthContent_widthContent__app__enDI9"};